import React from 'react';
import PropTypes, { string, object } from 'prop-types';
import styled from 'styled-components';
import { Col } from 'react-materialize';
import { SCREEN_MEDIA, COLOR, SIZE } from '../../utils/constants.js';
import { LabelSailecBold, LabelMonaco } from '../atoms/label.jsx';
import Row from './row.jsx';
import TitleSect from '../atoms/titlesect.jsx';
import Bullets from '../molecules/bullets.jsx';


const Content = styled.div`
    margin: 0 0 0 25px;
`;

const ImageCenterContent = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 50px 0 0 0;
`;

const Image = styled.img`
    height: ${props => props.img_height ? props.img_height : 'none'};
    width: ${props => props.img_width ? props.img_width : 'none'};
    @media only screen and ${SCREEN_MEDIA.small} {
        height: ${props => props.height_small ? props.height_small : 'none'};
        width: ${props => props.width_small ? props.width_small : 'none'};
    }
    @media only screen and ${SCREEN_MEDIA.medium} {
        height: ${props => props.height_small ? props.height_small : 'none'};
        width: ${props => props.width_small ? props.width_small : 'none'};
    }
`;

const Subtitle = styled(LabelSailecBold)`
    font-size: ${SIZE.title};
    color: ${COLOR.gray};
    margin: 30px 0 0 0;
`;

const Description = styled(LabelMonaco)`
    margin: ${props => props.margin ? props.margin : '0 0'};
    color: ${COLOR.black};
    font-size: ${SIZE.body};
    line-height: 2.2em;
`;

const DescsContent = styled.div`
    margin: 35px 0 0 0;
`;

const RowInfo = (props) => {

    const listDesc = props.descs?.map((desc, index) =>
        <Description
            key={index}
            text_color={COLOR.black}
            text_size={SIZE.body}
            margin='25px 0 0 0'>
            {desc}
        </Description>
    );
    const descs = <DescsContent>{listDesc}</DescsContent>


    if(props.img_right === true) {
        return (
            <Row className='valign-wrapper' margin={props.margin} padding={props.padding}>
                <Col s={12} m={12} l={6} xl={6}>
                    <Content>
                        <TitleSect  margin='30px 0'>{props.title}</TitleSect>
                        {descs}
                        <Bullets items={props.bullet_items}/>

                        <Subtitle>
                            {props.subtitle1}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc1}
                        </Description>

                        <Subtitle>
                            {props.subtitle2}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc2}
                        </Description>
                    </Content>
                </Col>
                <Col s={12} m={12} l={6} xl={6}>
                    <ImageCenterContent>
                        <Image 
                            className='responsive-img'
                            src={props.img_path}
                            height={props.img_height}
                            width={props.img_width}
                            height_small={props.img_height_small}
                            width_small={props.img_width_small}/>
                    </ImageCenterContent>
                </Col>
            </Row>
        );
    } else {
        return (
            <Row className='valign-wrapper' margin={props.margin} padding={props.padding}>
                <Col s={12} m={12} l={6} xl={6}>
                    <ImageCenterContent>
                        <Image 
                            className='responsive-img'
                            src={props.img_path}
                            height={props.img_height}
                            width={props.img_width}
                            height_small={props.img_height_small}
                            width_small={props.img_width_small}/>
                    </ImageCenterContent>
                    
                </Col>
                <Col s={12} m={12} l={6} xl={6}>
                    <Content>
                        <TitleSect margin='30px 0'>{props.title}</TitleSect>
                        {descs}
                        <Bullets items={props.bullet_items}/>

                        <Subtitle>
                            {props.subtitle1}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc1}
                        </Description>

                        <Subtitle>
                            {props.subtitle2}
                        </Subtitle>
                        <Description margin='10px 0px'>
                            {props.desc2}
                        </Description>
                    </Content>
                </Col>
            </Row>
        );
    }
    
}

RowInfo.propTypes = {
    img_path: PropTypes.string.isRequired,
    img_height: PropTypes.string,
    img_height_small: PropTypes.string,
    img_width: PropTypes.string,
    img_width_small: PropTypes.string,
    img_right: PropTypes.bool,
    title: PropTypes.string,
    descs: PropTypes.arrayOf(string),
    bullet_items: PropTypes.arrayOf(object),
    subtitle1: PropTypes.string,
    desc1: PropTypes.string,
    subtitle2: PropTypes.string,
    desc2: PropTypes.string,
    margin: PropTypes.string,
    padding: PropTypes.string
}

export default RowInfo;